import '../../resources/css/maintenance/CompanyInfoForm.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';
import { commonRenderInput } from '../../components/common/access-form';
import { verifyForm, verifyWebUrl } from '../../components/common/access-form-validation';
import Loading from '../../components/common/Loading';
import { saveCompanyInfo, SAVE_COMPANY_INFO_SUCCESS, SAVE_COMPANY_INFO_FAIL } from '../../actions/company/index';

class CompanyInfoForm extends Component {

    formSubmit = (values) => {
        const { idToken, saveCompanyInfo } = this.props;

        const reqBodyObj = {
            companyName: 'Pacific',
            ContactURL: values.ContactURL,
            FAQURL: values.FAQURL,
            WarranyRegistrationURL: values.WarranyRegistrationURL
        };

        saveCompanyInfo(idToken, reqBodyObj);
    }

    componentDidUpdate (prevProps, prevState, snapshot) {        
        const { status, errMsg, successMsg } = this.props;

        if (prevProps.status !== status) {
            // init do init
            if (status === SAVE_COMPANY_INFO_SUCCESS) {
                if (successMsg) {
                    console.info("successMsg", successMsg);
                    alert(successMsg);
                }
            }

            if (status === SAVE_COMPANY_INFO_FAIL) {
                if (errMsg) {
                    console.error("errMsg", errMsg);
                    alert(errMsg.errMsg);
                }
            }
        }
    }

    render() {
        const { handleSubmit, readOnly, loading, verifyFormPass } = this.props;

        if (loading) {
            return (
                <Loading loading={true}></Loading>
            );
        }

        // load submit button content
        let btnSubmit = (
            <Row>
                <Col md={2} xl={4}>&nbsp;</Col>
                <Col md={8} xl={4}>
                    <Button type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>Save</Button>
                </Col>
                <Col md={2} xl={4}>&nbsp;</Col>
            </Row>
        );
        
        return (
            <div className="company-info-form form-custom">
                <div className='form-title'>Pacific Info</div>
                <form onSubmit={handleSubmit(this.formSubmit)}>
                    <Field name="ContactURL" type="text" component={commonRenderInput} label="Contact Us Url" disabled={readOnly} validate={verifyWebUrl} />
                    <Field name="FAQURL" type="text" component={commonRenderInput} label="FAQ Url" disabled={readOnly} validate={verifyWebUrl} />
                    <Field name="WarranyRegistrationURL" type="text" component={commonRenderInput} label="Warranty Registration Link" disabled={readOnly} validate={verifyWebUrl} />
                    { btnSubmit }
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const companyInfo = state.companyReducers.companyInfo;
    const verifyFormPass = verifyForm(state.form['CompanyInfoForm']);

    let ret = {
        idToken: state.logindReducers.idToken,
        status: state.companyReducers.status,
        loading: companyInfo.loading,
        readOnly: false,
        verifyFormPass : verifyFormPass,
        successMsg: state.companyReducers.successMsg,
        errMsg: state.companyReducers,
    }

    const companyInfoForm = state.form.CompanyInfoForm;
    if (companyInfo && !companyInfo['loading'] && companyInfoForm && !companyInfoForm['initial']) {
        let initialValues = {};
        initialValues['ContactURL'] = companyInfo['ContactURL'];
        initialValues['FAQURL'] = companyInfo['FAQURL'];
        initialValues['WarranyRegistrationURL'] = companyInfo['WarranyRegistrationURL'];

        ret['initialValues'] = initialValues;
    }

    return ret;
}

CompanyInfoForm = reduxForm({
    form: 'CompanyInfoForm',  // a unique identifier for this form
})(CompanyInfoForm)
  
export default connect(
    mapStateToProps,
    { saveCompanyInfo }
)(CompanyInfoForm);